<div class="task-position-details">
  <div class="layout">
    <div class="task-list">
      <div class="position" *ngFor="let position of taskPositions">
        <app-list-title>{{position.name}}</app-list-title>
        <ng-container *ngFor="let t of position.tasks">
          <app-task-list-entry [task]="t" [selected]="t === selectedTask" (click)="selectTask(t)"></app-task-list-entry>
          <sc-list-spacer></sc-list-spacer>
        </ng-container>
      </div>
    </div>
    <div class="task-position-button-bar">

      <app-service-response [responseMessages]="responseMessages"></app-service-response>

      <button class="hint-button" mat-stroked-button (click)="showProcessingHint(selectedTask)"
        [disabled]="selectedTask == null ||selectedTask.processingHint == null || selectedTask.processingHint.length == 0">
        <i class="far fa-question"></i>
      </button>

      <button mat-flat-button (click)="completeTask(selectedTask)" class="confirm-button"
        [disabled]="isCompleteMessageTaskDisabled(selectedTask)" *ngIf="isMessageTask(selectedTask)">
        {{'complete message' | translate:['tmc.task-position-details.action.complete-message',
        translationService.language]}}
      </button>

      <button mat-flat-button (click)="completeTask(selectedTask)" class="confirm-button"
        [disabled]="isCompleteTaskDisabled(selectedTask)" *ngIf="isCheckTask(selectedTask)">
        {{'complete check' | translate:['tmc.task-position-details.action.complete-check',
        translationService.language]}}
      </button>

      <button mat-flat-button (click)="completeDocumentTask(selectedTask)" class="confirm-button"
        *ngIf="isDocumentTask(selectedTask)">{{getDocumentTaskTitle(selectedTask)}}
      </button>

      <button mat-flat-button class="confirm-button" [disabled]="isCompleteTaskDisabled(selectedTask)"
        (click)="pictureInput.click()" *ngIf="isPictureTask(selectedTask)">
        {{'take picture' | translate:['tmc.task-position-details.action.complete-picture',
        translationService.language]}}
        <input id="picture-btn" #pictureInput name="picture-btn" type="file" accept="image/*"
          (change)="completePictureTask($event)" style="display: none;" />
      </button>
    </div>
  </div>
</div>